import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import OasisPoolHeader from './OasisPoolHeader';
import EventsInline from './EventsInline';
import OasisUtils from './OasisUtils';

import UITableUtils from "../util/UITableUtils";
// import OasisSignByHour from './OasisSignByHour';
// import OasisSignByDate from './OasisSignByDate';
import OasisPoolInline from './OasisPoolInline';
import OasisPoolNav from './OasisPoolNav';
import ApiUtils from '../util/ApiUtils';
import SPUtilities from '../util/SPUtilities';
import UIUtils from '../util/UIUtils';
import Utilities from '../util/Utilities';
import UINotes from "../util/UINotes";
import ChartUtils from "../util/ChartUtils";
import RespUtils from "../util/RespUtils";

import BaseBarChart from "../reports/BaseBarChart";
import StackedBarChart from "../reports/StackedBarChart";

class OasisPool extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pool: {},
      epochSummary: [],
      dailySummary: [],
      events: [],
      width: window.innerWidth,
      size: 10,
      responsive: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    var poolId = SPUtilities.getPoolId(this);
    // console.log("componentDidMount - after poolId: ", poolId);
    const allData = await ApiUtils.get("listData?type=getOasisPool&poolId=" + poolId);
    // console.log("allData is:", allData);

    if (allData) {
      // console.log(allData);
      let pool = allData["pool"];
      // let hourlyChartData = allData["hourlyChartData"];
      // let dailyChartData = allData["dailyChartData"];
      let dailySummary = allData["dailySummary"];
      let epochSummary = allData["epochSummary"];
      let events = Utilities.addIndex(allData["events"]);
      this.setState({pool: pool, isLoading: false,
        "epochSummary": epochSummary, "dailySummary": dailySummary,
        "events": events});
      // "hourlyChartData": hourlyChartData,
      // "dailyChartData": dailyChartData,
    }
  }

  render() {
    // console.log("in render, pool : ", this.state.pool);
    // console.log("in render, this.state.isLoading : ", this.state.isLoading);
    if (this.state.isLoading) {
      return <div>Loading</div>;
    }

    if (this.state.pool.poolId === undefined) {
      return <div>Still loading</div>;
    }


    var columns;
    if (RespUtils.isMobileView()) {
      columns = [
          {text: "Date",dataField: "syncTime", sort: true, headerStyle: Utilities.width(45)},
          {text: "Sign", dataField: "signatures", sort: true,  sortFunc: Utilities.sortNumeric,  headerStyle: Utilities.width(14)},
          {text: "Prop osal", dataField: "proposals", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(14)},
          {text: "Score", dataField: "availabilityScore", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(14)},
          {text: "Sign %", dataField: "signPer", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(14)},
        ];
    } else {
      columns = [
          {text: "Date",dataField: "syncTime", sort: true, headerStyle: Utilities.width(30)},
          {text: "Signs", dataField: "signatures", sort: true,  sortFunc: Utilities.sortNumeric,  headerStyle: Utilities.width(18)},
          {text: "Proposals", dataField: "proposals", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
          {text: "Score", dataField: "availabilityScore", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(17)},
          {text: "Sign %", dataField: "signPer", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
        ];
    }

    const options = UIUtils.getPageOptionsSmall(this, 10);
    const defaultSorted = [{
      dataField: 'syncTime',
      order: 'desc' // desc or asc
    }];

    return (
      <div>
        <p/>
        <OasisPoolHeader pool={this.state.pool} notification={this.state.notification} desktopView={true} title="Summary"/>
        <OasisPoolInline pool={this.state.pool} hideNav={true}/>

        <hr/>
        <BaseBarChart title="Epoch Signed Percentage" xAxis="Epoch" yAxis="Sign Percentage"
          showVerticalLabel={true} valueAttr="perSigned" showTotalLabel={false}
          data={this.state.epochSummary} xAxisValueAttr="epoch" />
        <hr/>
        <StackedBarChart title="Epoch Signatures" xAxis="Epoch" yAxis="Signatures"
          showVerticalLabel={true} valueAttr="signatures" valueAttr2="missedBlocks" showTotalLabel={false}
          data={this.state.epochSummary} verticalLabel={true}  xAxisValueAttr="epoch" />
        <hr/>
        <StackedBarChart title="Daily Signatures" xAxis="Date" yAxis="Signatures"
          showVerticalLabel={true} valueAttr="signatures" valueAttr2="notSigned" showTotalLabel={false}
          data={this.state.dailySummary} verticalLabel={false}  xAxisValueAttr="syncDate" />


        {this.state.events.length > 0 && this.renderEvents()}
        <OasisPoolNav poolId={this.state.pool.poolId}/>
      </div>
    );
  }

  // <hr/>
  // <p/><p><b>Hourly Performance Stats (GMT Time)</b></p>
  // <BootstrapTable keyField='poolId' data={ this.state.epochSummary}
  //   columns={ columns } striped striped options={options} defaultSorted={defaultSorted}
  //   condensed noDataIndication="Table is Empty/Loading"
  //   />
  // <hr/>
  // <p/><p><b>Daily Performance Stats</b></p>
  // <BootstrapTable keyField='poolId' data={ this.state.dailySummary}
  //   columns={ columns } striped striped options={options} defaultSorted={defaultSorted}
  //   condensed noDataIndication="Table is Empty/Loading"
  //   />

  renderEvents() {
    return (
      <div>
        <hr/>
        <p/>
        <h4 style={{align: "center"}}><span><strong>Recent Events</strong></span></h4>
        {OasisUtils.renderEventTypes(this)}
        <EventsInline data={this.state.events} />
      </div>
    )
  }

}

export default OasisPool;

/*

  <hr/>
  {ChartUtils.renderLines(this, "Daily Performance", this.state.dailyChartData, "Performance", "availabilityScore",
    "signatures", "proposalsX50", "availabilityScore")}
  <hr/>
  {ChartUtils.renderLines(this, "Hourly Performance (GMT)", this.state.hourlyChartData, "Performance", "availabilityScore",
    "signatures", "proposalsX50", "availabilityScore")}
    {this.getBreadCrumb()}
    <h4 style={{align: "center"}}><span><strong>{this.state.pool.entityName} - Summary</strong></span>{UIUtils.renderReload()}{UITableUtils.renderSwitchView(this)}</h4>
    {SPUtilities.getLastUpdatedGap(this.state.pool.lastUpdatedGap)}

*/



// WEBPACK FOOTER //
// ./src/oasis/OasisPool.js